/**
 * Code utilisé par les flexibles content "bloc_header_offer" ou "form_search_offres" ou "homepage_header" ( Flexible content homepage_header.php)
 * ce code permet de mémoriser la recherche  d'adresse effectué sur ces blocs pour 
  */

 (function(w) {
    w.Kinougarde = Object.assign({},w.Kinougarde, { RechercheOffres : {}});
   

    /**
     * Initialisation du formulaire de recherche des offres sur la page /offres-emploi/
     */
     w.Kinougarde.RechercheOffres.initFormulaire = function($form ,modeRecherchenounou = true) {   
         
        let defautlValue = Kinougarde.GetStorage("form-recherche-offres");
                
        if (new RegExp(/offres-emploi\/[^\/]+-\d{5}\/?/).test(document.location.pathname)) {
            // Nous somme une une page du type /offre-emploi/paris-75019/   
            // Il faut recupérer les infos de localisation pour initialiser
            // l'autocomplete google
            var filtre = { adresse : $("[data-filtre-geocode]").data("filtre-geocode"),                           
                           adresse_lat :  jQuery("[data-filtre-latitude]").data("filtre-latitude"),
                           adresse_lng :  jQuery("[data-filtre-longitude]").data("filtre-longitude"),
                           adresse_postal_code :  jQuery("[data-filtre-codepostal]").data("filtre-codepostal"),
                           adresse_locality :  jQuery("[data-filtre-ville]").data("filtre-ville")
                        }
            Kinougarde.SetStorage("form-recherche-offres",filtre);
            $("#adresse").SetLocalisation(
                filtre.adresse,
                filtre.adresse_lat,
                filtre.adresse_lng,
                filtre.adresse_locality,
                filtre.adresse_postal_code);
                      
        }  
        //Valeur par défaut du formulaire
        else if (typeof(defautlValue)!=='undefined' && defautlValue!==null) {
            $("#adresse").SetLocalisation(
                defautlValue.adresse,                
                defautlValue.adresse_lat,
                defautlValue.adresse_lng,
                defautlValue.adresse_locality,
                defautlValue.adresse_postal_code);
        }

       // Clic sur le bouton trouver
       $form.find("button").on('click',function(e) {
        e.preventDefault();                
        $form.parsley().validate();
        if ($form.parsley().isValid()) {    
            let data = {};
            // Recupère toutes les valeurs des champs du formulaire pour les stocker dans un javascript
            $form.serializeArray().forEach(function(value, key){
                data[value['name']]= (typeof(value['value'])!==undefined && value['value']!=="" ? value['value'] : null)}
            ); 

            if (document.location.pathname==="/offres-emploi/") {
                // On est déjà sur la page /offres-emploi/
                // On notifie qu'une recherche est à faire
                $(document).trigger('recherche-offres', [data]);
            }            
            $form.find("button").loading(            
            $.ajax({
                type     : 'POST',
                dataType : 'json',
                url      : ajax_kinougarde_object.ajaxurl,
                data     : Object.assign({'action':'est_desservie'},data),
                success  : function (rep) {              
                    if (rep.success || (typeof(rep.data.error_code)!=='undefined' && rep.data.error_code==='NON_DESSERVIE')) {  
                        Kinougarde.SetStorage("form-recherche-offres",data);                                              
                        // Bloc de recherche d'un emploi
                        if(rep.data.NouvelleAgence==true) {
                            //Redirection vers postuler
                            document.location = "/postuler/?ag=" + rep.data.IdAgence;
                            Kinougarde.TagManagerTunnel('Offres/step-0',{event : 'TunnelRedirection', TunnelStepRedirect : 'Postuler/step-1'});                                    
                        } else {                            
                            if (document.location.pathname!=="/offres-emploi/") {                                
                                // On est pas sur la page /offres-emploi/ on redirige vers cette page
                                document.location = "/offres-emploi/";                                
                            }
                        }                        
                    }                    
                    else {                        
                        var msg = Kinougarde.Form.getMessageErrorAjax(rep);
                        $form.find(".form-group").after(msg);
                        Kinougarde.TagManagerTunnel('Offres/step-0',{event : 'GTMerror', ErrorType: msg});
                    }
                },
                error : function (error) {                    
                    var msg = Kinougarde.Form.getMessageErrorAjax(rep);
                    $form.find(".form-group").after(msg);
                    Kinougarde.TagManagerTunnel('Offres/step-0',{event : 'GTMerror', ErrorType: msg});              
                }
            }));    
            return;                
        }
    });
    }

    

 })(window);

 jQuery(function() {
    try {        
        // Bloc de recherche des offres
        if (jQuery("#section-recherche-offres").length>0) {
            Kinougarde.RechercheOffres.initFormulaire(jQuery("#section-recherche-offres").find("form"));
        }
        // Bloc de recherche des offres sur la page /nounou/
        if (jQuery("#section-home-recherche-offres").length>0) {
            Kinougarde.RechercheOffres.initFormulaire(jQuery("#section-home-recherche-offres").find("form"));
        }
    }     
    catch (ex) {
        console.error(ex);
    }
});